import {InjectionToken, Provider} from '@angular/core';

export const ARTICLE_BLOCK_MAX_IMAGE_HEIGHT = new InjectionToken<number>(
  'Provides value for max article block thumbnail image height.',
);

export const ARTICLE_BLOCK_PROVIDERS: Provider[] = [
  {
    provide: ARTICLE_BLOCK_MAX_IMAGE_HEIGHT,
    useValue: 300,
  },
];
